import { ReviewArtworkContextPanelGroup } from "./ReviewArtworkContextColumns";

import { type ProjectFileTagSource } from "../utils/matchProjectFileForReview";
import { type UsedConnector } from "../utils/usedConnectors";

interface CampaignReviewPaneProps {
  /** The review ticket to display (artwork + AI comments + context). */
  ticketId: string;
  /** Close the review screen and return to the default project view. */
  onClose: () => void;
  /** Deep-link hydration: select this comment once comments load. */
  initialCommentId?: string | null;
  /** Push comment selection into the URL (PUSH navigation). */
  onCommentDeepLinkChange?: (commentId: string | null) => void;
  onInvalidCommentDeepLink?: () => void;
  /** External connectors invoked for this review ticket. */
  usedConnectors?: readonly UsedConnector[];
  /** Project + active file for per-file tags in the artwork header. */
  projectId?: string;
  fileId?: string;
  fileTags?: string[];
  projectFiles?: ProjectFileTagSource[];
}

/**
 * The project review screen: artwork in the center, with comments and
 * context/reference documents sharing the right column (comments top half,
 * context assets bottom half, or blank space when no context files exist).
 *
 * Selection state (active comment + citation highlight) mirrors
 * `TicketViewPane`, but the layout is intentionally different: the project
 * workspace keeps the feed/chat visible on the left, so this pane owns the
 * artwork viewer and the stacked comments + context column.
 */
export function CampaignReviewPane({
  ticketId,
  onClose,
  initialCommentId,
  onCommentDeepLinkChange,
  onInvalidCommentDeepLink,
  usedConnectors,
  projectId,
  fileId,
  fileTags,
  projectFiles,
}: CampaignReviewPaneProps) {
  return (
    <ReviewArtworkContextPanelGroup
      ticketId={ticketId}
      onClose={onClose}
      initialCommentId={initialCommentId}
      onCommentDeepLinkChange={onCommentDeepLinkChange}
      onInvalidCommentDeepLink={onInvalidCommentDeepLink}
      usedConnectors={usedConnectors}
      projectId={projectId}
      fileId={fileId}
      fileTags={fileTags}
      projectFiles={projectFiles}
    />
  );
}
